import { render } from "./AdminEmails.vue?vue&type=template&id=3049e266"
import script from "./AdminEmails.vue?vue&type=script&lang=js"
export * from "./AdminEmails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__